import { useDispatch, useSelector } from "react-redux";
import { setRadioGroup } from "../../../redux/filtersSlice"; // Adjust the path to your slice
import { useEffect } from "react";

const RadioGroup = ({ filterId, options, selected, label }) => {
  const dispatch = useDispatch();
  const drawerOpen = useSelector((state) => state.view.drawer);

  // Get the selected value from Redux state
  const selectedValue = useSelector(
    (state) => state.filters.radioGroup[filterId] ?? selected,
  );

  const handleChange = (value) => {
    // Dispatch the selected value to Redux
    dispatch(setRadioGroup({ filterId, selectedValue: value }));
  };

  useEffect(() => {}, [selectedValue]);

  return (
    <div className={`${drawerOpen ? "" : "hidden"}`}>
      <div className="space-y-2">
        {options.map((option) => (
          <label
            key={option.value}
            className={`flex items-center gap-1 p-1 border rounded-lg cursor-pointer transition text-[12px] ${
              selectedValue === option.value
                ? "border-blue-500 bg-blue-50 shadow-md"
                : "border-gray-300"
            } hover:border-blue-400`}
          >
            <input
              type="radio"
              value={option.value}
              checked={selectedValue === option.value}
              onChange={() => handleChange(option.value)}
            />
            {option.label}
          </label>
        ))}
      </div>
    </div>
  );
};

export default RadioGroup;
